"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClubInvoiceDetailPage = void 0;
var ClubInvoiceDetail_1 = require("./ClubInvoiceDetail");
Object.defineProperty(exports, "ClubInvoiceDetailPage", { enumerable: true, get: function () { return ClubInvoiceDetail_1.ClubInvoiceDetailPage; } });
